import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { ContentProvider } from './contexts/ContentContext'
import Hero from './components/Hero'
import Collections from './components/Collections'
import Products from './components/Products'
import About from './components/About'
import Testimonials from './components/Testimonials'
import ContactForm from './components/ContactForm'
import Footer from './components/Footer'
import Navbar from './components/Navbar'
import WhatsAppButton from './components/WhatsAppButton'
import Admin from './pages/Admin'
import BoysCollection from './pages/BoysCollection'
import GirlsCollection from './pages/GirlsCollection'
import Privacy from './pages/Privacy'
import Terms from './pages/Terms'

// Componente para la landing page principal
const LandingPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <Hero />
        <Collections />
        <Products />
        <About />
        <Testimonials />
        <ContactForm />
      </main>
      <Footer />
    </div>
  )
}

function App() {
  return (
    <ContentProvider>
      <Router>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/panel-jk-stock" element={<Admin />} />
          <Route path="/coleccion-ninos" element={<BoysCollection />} />
          <Route path="/coleccion-ninas" element={<GirlsCollection />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
        </Routes>
      </Router>
      <WhatsAppButton />
    </ContentProvider>
  )
}

export default App

